import { config } from '../../../../utils/config';
import Link from '../../../atoms/Link';
import './style.scss';

type ItemHeadingProps = {
  name: string;
  brand: string;
  href: string;
};

const ItemHeading = ({ name, brand, href }: ItemHeadingProps) => {
  const { hasDisabledLinks, hideBrands } = config.basket;
  const isAmazonPayReviewPage = !!new URLSearchParams(window.location.search).get('isAmazonPayReviewPage');

  return (
    <div className="item-heading">
      <Link className="item-heading__link" href={href} isDisabled={hasDisabledLinks || isAmazonPayReviewPage}>
        {!hideBrands && (
          <span className="item-heading__brand" data-test-id="item-brand">
            {brand}
          </span>
        )}
        <p className="item-heading__title" data-test-id="item-name">
          {name}
        </p>
      </Link>
    </div>
  );
};

export default ItemHeading;
